import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@systemeio/ui';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { ACTION_KEY } from '../constants';
import { BaseTableProps } from './base-table';
import { TableSortElement } from './table-sort-element';
interface TableHeaderProps<T> extends Pick<BaseTableProps<T>, 'columns'> {
  totalWidth: number;
}
export function TableHeader(t0) {
  const $ = _c(8);
  const {
    columns,
    totalWidth
  } = t0;
  let t1;
  if ($[0] !== columns || $[1] !== totalWidth) {
    let t2;
    if ($[3] !== columns.length || $[4] !== totalWidth) {
      t2 = (column, index) => {
        const widthPercent = column.widthPercent || 25;
        const isFirst = index === 0;
        const isLast = index === columns.length - 1;
        return <div key={`headCell-${index}`} className={twMerge("text-text-primary font-inter text-start hidden truncate p-4 text-[17px] font-bold lg:flex lg:items-center", column.sort && "cursor-pointer", column.className, isFirst && "pl-6", isLast && "pr-6")} style={{
          width: `${column.key === ACTION_KEY && "82px"}`,
          flex: `${column.key !== ACTION_KEY && `${widthPercent / totalWidth * 100}`}`
        }} onClick={column.sort?.onSortOrderChange}>{typeof column.header === "string" ? <div className="w-full"><Tooltip mode="overflow" label={column.header}>{column.header}</Tooltip></div> : column.header}{column.sort && <TableSortElement sortOrder={column.sort.sortOrder} onSortOrderChange={column.sort.onSortOrderChange} className="ml-2" />}</div>;
      };
      $[3] = columns.length;
      $[4] = totalWidth;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = columns.map(t2);
    $[0] = columns;
    $[1] = totalWidth;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const headers = t1;
  let t2;
  if ($[6] !== headers) {
    t2 = <div className="bg-brand-primary-subtle flex items-center">{headers}</div>;
    $[6] = headers;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}